module.exports = __webpack_public_path__ + "static/media/ALTHAR_LOGO_VERDE.e494aa8a.svg";